import { Component } from 'preact'
import axios from 'axios'
import Header from '../../header'
import CategoryManager from '../../category/control/CategoryManager'
import EmptyPage from '../../empty-page/EmptyPage'
import AlertComponent from '../../ui-components/AlertComponent'
import ButtonControl from '../../button-control'

class KnowledgeBaseManager extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      categoryList: JSON.parse(props.categories)
    }
    this.originalCategoryList = JSON.parse(props.categories)
    this.onUnload = this.onUnload.bind(this)
    this.updateCategoriesOrder = this.updateCategoriesOrder.bind(this)
  }

  saveChanges () {
    const newData = this.state.categoryList
    axios.post('/platform/knowledge-base/reorder', newData)
      .then(() => {
        this.setState({ messageType: 'success' }, () => window.setTimeout(() => this.setState({ messageType: null }), 5000))
        this.originalCategoryList = this.state.categoryList
      })
      .catch(() => {
        this.setState({ messageType: 'error' }, () => window.setTimeout(() => this.setState({ messageType: null }), 5000))
      })
  }

  hasChanged () {
    return JSON.stringify(this.state.categoryList) !== JSON.stringify(this.originalCategoryList)
  }

  componentDidMount () {
    window.addEventListener('beforeunload', this.onUnload)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onUnload)
  }

  onUnload (event) {
    if (this.hasChanged()) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  updateCategoriesOrder (newOrderedList) {
    this.setState({ categoryList: newOrderedList })
  }

  render (props, state) {
    const categories = state.categoryList

    return (
      <div className='category-manager_container knowledge-base-control'>
        <Header
          title='Knowledge Base'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <ButtonControl
              title={categories.length ? 'Save changes' : ''}
              variant='success'
              onClick={() => this.saveChanges()}
              class='js-submit'
            />,
            <a href='/platform/knowledge-base/new'>
              <ButtonControl
                title='Add parent category'
                variant='primary'
              />
            </a>
          ]}
        />
        <AlertComponent messageType={state.messageType} />
        {
          !categories.length ? (
            <EmptyPage
              img_src={`${props.defaultCdn}/images/empty_page.png`}
              header='Your knowledge base is still empty'
              text='Start now by adding the first parent category.'
            />
          ) : <CategoryManager
            addCategoryLink='/platform/knowledge-base/new'
            editCategoryLink='/platform/knowledge-base/edit'
            updateCategoriesOrder={this.updateCategoriesOrder}
            categories={categories} />
        }
      </div>
    )
  }
}

export default KnowledgeBaseManager
